// Data
import actionsServiceCaller from '../lib/app/actions-service-caller';

// Configs
import servicesFormConfig from '../../config/services-form-config';

export function generateMarker({guid, markerType, forceRegenerate, forceIncludeFirstEpisode}) {
    return (dispatch) => {
        const dispatchFetched = (jsonResponse) => {
            dispatch({
                type: 'GENERATE_MARKER_FULFILLED',
                response: jsonResponse || `Marker generation request queued for ${markerType}.`,
                markerType,
            });
        };
        const dispatchError = (error) => {
            dispatch({
                type: 'GENERATE_MARKER_REJECTED',
                error,
                markerType,
            });
        };

        const queryParams = {guid, markerType};

        if (forceRegenerate) {
            queryParams.forceRegenerate = true;
        }
        if (markerType === 'FINGERPRINT' && forceIncludeFirstEpisode) {
            queryParams.forceIncludeFirstEpisode = true;
        }

        const actionParams = {
            servicesConfig: servicesFormConfig.generateMarker,
            dispatchFetched,
            dispatchError,
        };

        dispatch({
            type: 'GENERATE_MARKER',
            markerType,
        });

        return actionsServiceCaller(actionParams, queryParams);
    };
}

export function generateMarkerReset() {
    return (dispatch) => {
        dispatch({
            type: 'GENERATE_MARKER_RESET',
        });
    };
}
